<template>
  <div class="payment-complete">
    <h1 v-if="result === 'success'">✅ Payment Successful</h1>
    <h1 v-else-if="result === 'failed'">❌ Payment Failed</h1>
    <h1 v-else>ℹ️ Payment Status Unknown</h1>

<p v-if="result === 'success'">
  <span v-if="subscriptionDays">
    You've activated a <strong>{{ subscriptionDays }}-day subscription</strong> on your account.
  </span>
  <span v-else>
    You've successfully added <strong>{{ creditsEarned }} credits</strong> to your account.
  </span>
</p>


    <p v-else-if="result === 'failed'">
      Your payment attempt did not go through. You can try again or contact support.
    </p>
    <p v-else>
      We couldn't determine the result of your payment. You may need to refresh or try again.
    </p>

    
    <div class="summary">
      <h3>Next Steps</h3>
      <ul>
        <li v-if="result === 'success'">
          ➡️ You can now use <strong>Pathtracer</strong> to analyze your transaction hashes.
        </li>
        <li>➡️ Review your balance on <strong>My Account</strong>.</li>
        <li v-if="result !== 'success'">➡️ Try again to complete your payment.</li>
        <li>📬 Contact support if you believe something went wrong.</li>
      </ul>
    </div>

    <div class="button-group">
      <router-link class="button primary" :to="{ name: 'AnalysisTool' }" v-if="result === 'success'">
        Use Pathtracer Now
      </router-link>
      <router-link class="button" :to="{ name: 'AccountPage' }">
        Go to My Account
      </router-link>
      <router-link class="button" :to="{ name: 'StripeProductChooser' }" v-if="result !== 'success'">
        Try Again
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentCompleteOld',
data() {
  return {
    result: '',
    creditsEarned: 0,
    subscriptionDays: 0
  };
},

created() {
  const query = new URLSearchParams(this.$route.query);
  this.result = query.get('result') || 'unknown';
  this.creditsEarned = parseInt(query.get('credits') || '0');
  this.subscriptionDays = parseInt(query.get('subscriptionDays') || '0');
}

};
</script>

<style scoped>
.payment-complete {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
  padding: 40px 20px;
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
h1 {
  margin-bottom: 16px;
}
.summary {
  text-align: left;
  margin: 24px auto;
  max-width: 460px;
}
.summary ul {
  list-style-type: none;
  padding-left: 0;
}
.summary li {
  margin: 10px 0;
}
.button-group {
  margin-top: 24px;
}
.button {
  display: inline-block;
  margin: 10px;
  padding: 12px 24px;
  background-color: #3498db;
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.2s;
}
.button.primary {
  background-color: #2ecc71;
}
.button.primary:hover {
  background-color: #27ae60;
}
.button:hover {
  background-color: #2980b9;
}
</style>
